import { __makeTemplateObject } from "tslib";
import { css } from '@skbkontur/react-ui/lib/theming/Emotion';
import { memoizeStyle } from '../../../lib/theming/ThemeHelpers';
var styles = {
    row: function () {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      display: flex;\n      align-items: center;\n    "], ["\n      display: flex;\n      align-items: center;\n    "])));
    },
    label: function () {
        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      width: 160px;\n    "], ["\n      width: 160px;\n    "])));
    },
    field: function () {
        return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      flex-grow: 2;\n    "], ["\n      flex-grow: 2;\n    "])));
    },
};
export var jsStyles = memoizeStyle(styles);
var templateObject_1, templateObject_2, templateObject_3;
